import {SharedQuestion} from "./SharedQuestion";

export class SubmitSharedQuestion extends SharedQuestion {

    public question:IQuestion;
    protected value:IValue;

    isValid():boolean {
        super.isValid();

        return true;
    }

    validationMessage() : string {
        return null;
    }

    getValue():IValue {
        return this.value;
    }

    setValue(value:any) {
        this.value = value;
    }

    satisfiesValue(currentValues:IValue[], value:IValue):boolean {
        return value.joinResearchValue === currentValues[0].joinResearchValue;
    }

}